import React from "react";
import { Row, Col, Button, Input } from "antd";
import "../../components/EmployeCard/index.css";
import "./index.css";
import { AiOutlineSearch } from "react-icons/ai";
export default function ManufacturingPlants({
  inputText,
  inputTitle,
  RmxImage,
  onChangeFilter,
  onFilterSearch,
  ...props
}) {
  return (
    <Row>
      <Col xl={24} lg={24} sm={24} xs={24} md={24} className="rmx-container">
        <Row justify="center" align="middle">
          <Col xl={13} lg={12} sm={24} xs={24} md={24}>
            <Row justify="start" align="middle">
              <Col xl={24} xs={24}>
                <h1 className="rmx-heading4">
                  <span style={{ padding: "0px 0px" }}>
                    <img src={RmxImage} width="49" height="52" alt="" />
                  </span>
                  Manufacturing Plants
                  <span className="heading-textorange">in your region</span>
                </h1>
              </Col>
            </Row>
          </Col>
          <Col xl={10} lg={12} sm={24} xs={24} md={24}>
            <Row justify="space-between" align="middle" gutter={[10, 0]}>
              <Col span={8}>
                <Input
                  className="rmx-input"
                  type="text "
                  placeholder="Zip Code"
                  onChange={(e) => onChangeFilter(e.target.value)}
                />
              </Col>
              <Col span={16}>
                <Input
                  placeholder="Search..."
                  prefix={<AiOutlineSearch size={20} color="d3d3d3" />}
                  className="rmx-input"
                  onChange={(e) => onFilterSearch(e.target.value)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
